import { LOGOUT_REQUEST } from '@sit/client-shared';
import moment from 'moment';
import { handleActions } from 'redux-actions';
import { SimpleAction } from '../../types/redux/actions';
import { ClientsResponse, ClientsStore } from '../../types/redux/stores/clients.types';
import * as actionDefinitions from './actionDefinitions';

const initialState: ClientsStore = {
  data: [],
  error: null,
  initialLoad: false,
  lastSync: null,
  loading: false,
  saving: false,
};

const getClientsRequest = (state: ClientsStore): ClientsStore => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getClientsRequestFailure = (state: ClientsStore, action: SimpleAction): ClientsStore => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getClientsRequestSuccess = (state: ClientsStore, action: SimpleAction<ClientsResponse>): ClientsStore => {
  const data = action.payload?.res || [];
  return {
    ...state,
    data,
    error: null,
    initialLoad: true,
    lastSync: moment().toString(),
    loading: false,
  };
};

const getClientsStopLoading = (state: ClientsStore): ClientsStore => {
  return {
    ...state,
    loading: false,
  };
};

const logoutRequest = () => initialState;

export default handleActions(
  {
    [actionDefinitions.GET_CLIENTS_REQUEST]: getClientsRequest,
    [actionDefinitions.GET_CLIENTS_REQUEST_FAILURE]: getClientsRequestFailure,
    [actionDefinitions.GET_CLIENTS_REQUEST_SUCCESS]: getClientsRequestSuccess,
    [actionDefinitions.GET_CLIENTS_STOP_LOADING]: getClientsStopLoading,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
